export default __webpack_public_path__ + "static/media/profession.ef618809.svg";